/**
 * Mirrors App\Constants\UserLevels in portal-api. Keep the values in sync with
 * portal-api/app/Constants/UserLevels.php.
 *
 * Kept as flat named exports because callers do `import * as UserLevels` and
 * reference `UserLevels.Agent` directly.
 */
export const PinsAdmin = 1;
export const User = 2;
export const Agent = 3;
export const MasterAdmin = 4;

export const UserLevelLabels = {
  [PinsAdmin]: 'PINS Admin',
  [User]: 'User',
  [Agent]: 'Agent',
  [MasterAdmin]: 'Master Admin'
};

export const getUserLevelLabel = userLevel => UserLevelLabels[userLevel] ?? '';
